import React from 'react';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { formatCurrency } from '../../../utils/formatCurrency';
import { transformIngresosData, formatAbreviado } from './dataTransforms';

function CustomTooltip({ active, payload }) {
  if (!active || !payload || !payload.length) return null;
  const { name, monto } = payload[0].payload;
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #ccc',
        borderRadius: 4,
        padding: '8px 12px',
      }}
    >
      <p style={{ margin: 0, fontWeight: 'bold' }}>{name}</p>
      <p style={{ margin: 0 }}>{formatCurrency(monto)}</p>
    </div>
  );
}

export default function GroupedBarChart({ data }) {
  const chartData = transformIngresosData(data);

  if (!chartData || chartData.length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 300,
          color: '#999',
        }}
      >
        Sin datos de ingresos disponibles
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis tickFormatter={(value) => formatAbreviado(value)} />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="monto">
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.fill} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
